/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const BANCO_CHUVA_UF = {
  AC:{mm:1900,dias:140,regime:'Equatorial'}, AM:{mm:2200,dias:170,regime:'Equatorial'},
  AP:{mm:2400,dias:170,regime:'Equatorial'}, PA:{mm:2200,dias:140,regime:'Equatorial'},
  RO:{mm:2000,dias:140,regime:'Sazonal úmido'}, RR:{mm:1500,dias:130,regime:'Sazonal úmido'},
  TO:{mm:1500,dias:100,regime:'Sazonal seco'},
  AL:{mm:1300,dias:100,regime:'Sazonal úmido'}, BA:{mm:1100,dias:90,regime:'Sazonal seco'},
  CE:{mm:900,dias:80,regime:'Sazonal seco'}, MA:{mm:1700,dias:120,regime:'Sazonal seco'},
  PB:{mm:900,dias:80,regime:'Sazonal seco'}, PE:{mm:1100,dias:90,regime:'Sazonal úmido'},
  PI:{mm:1100,dias:90,regime:'Sazonal seco'}, RN:{mm:900,dias:80,regime:'Sazonal seco'},
  SE:{mm:1300,dias:100,regime:'Sazonal úmido'},
  DF:{mm:1500,dias:110,regime:'Sazonal seco'}, GO:{mm:1500,dias:110,regime:'Sazonal seco'},
  MT:{mm:1700,dias:120,regime:'Sazonal seco'}, MS:{mm:1400,dias:100,regime:'Sazonal seco'},
  ES:{mm:1300,dias:110,regime:'Regular'}, MG:{mm:1300,dias:100,regime:'Sazonal seco'},
  RJ:{mm:1500,dias:120,regime:'Regular'}, SP:{mm:1300,dias:100,regime:'Regular'},
  PR:{mm:1500,dias:110,regime:'Regular'}, RS:{mm:1500,dias:110,regime:'Regular'},
  SC:{mm:1700,dias:130,regime:'Regular'},
};
